// REMOVED: All requires and jQuery global assignments. 
// These are now handled in application.js to prevent conflicts.

$(document).on('turbolinks:load', function() {
// Check if DataTable is actually available to prevent the crash
    if (typeof $.fn.DataTable === 'undefined') {
        return;
    }

	// Table 1
    var table = $('#dttb').DataTable({
        scrollY: "700px",
        scrollX: true,
        scrollCollapse: true,
        paging: false,
        fixedColumns: true,
        colReorder: true,
        select: {
            style: 'multi'
        },
        "aoColumns": [
            null,
            { "orderSequence": ["desc", "asc"] },
            { "orderSequence": ["desc", "asc"] },
            { "orderSequence": ["desc", "asc"] },
            { "orderSequence": ["desc", "asc"] },
            { "orderSequence": ["desc", "asc"] },
            { "orderSequence": ["desc", "asc"] },
            { "orderSequence": ["desc", "asc"] },
            { "orderSequence": ["desc", "asc"] },
            { "orderSequence": ["desc", "asc"] },
            { "orderSequence": ["desc", "asc"] },
            { "orderSequence": ["desc", "asc"] },
            { "orderSequence": ["desc", "asc"] },
            { "orderSequence": ["desc", "asc"] },
            { "orderSequence": ["desc", "asc"] },
            { "orderSequence": ["desc", "asc"] },
            { "orderSequence": ["desc", "asc"] },
            { "orderSequence": ["desc", "asc"] },
            { "orderSequence": ["desc", "asc"] },
            null,
            null
        ],
        "columnDefs": [
            { "targets": [20], "visible": false, "searchable": true },
            { "targets": [21], "visible": false, "searchable": true }
        ]
    });

    // Table 2
    var table2 = $('#dttb2').DataTable({
        scrollY: "700px",
        scrollX: true,
        scrollCollapse: true,
        paging: false,
        fixedColumns: true,
        colReorder: true,
        select: {
            style: 'multi'
        },
        "aoColumns": [
            null,
            { "orderSequence": ["desc", "asc"] },
            { "orderSequence": ["desc", "asc"] },
            { "orderSequence": ["desc", "asc"] },
            { "orderSequence": ["desc", "asc"] },
            { "orderSequence": ["desc", "asc"] },
            { "orderSequence": ["desc", "asc"] },
            { "orderSequence": ["desc", "asc"] },
            { "orderSequence": ["desc", "asc"] },
            { "orderSequence": ["desc", "asc"] },
            { "orderSequence": ["desc", "asc"] },
            { "orderSequence": ["desc", "asc"] },
            { "orderSequence": ["desc", "asc"] },
            { "orderSequence": ["desc", "asc"] },
            { "orderSequence": ["desc", "asc"] },
            { "orderSequence": ["desc", "asc"] },
            { "orderSequence": ["desc", "asc"] },
            { "orderSequence": ["desc", "asc"] }
        ],
    });

    // Filter Logic
    $('#ctrl-show-by_status').on('change', function () {
        var val = $(this).val();
        $.fn.dataTable.ext.search.pop();
        if (val === 'established') {
            $.fn.dataTable.ext.search.push(
                function (settings, data, dataIndex) {
                    return data[21] == "Established"
                }
            )
        }
        else if (val === 'indev') {
            $.fn.dataTable.ext.search.push(
                function (settings, data, dataIndex) {
                    return data[21] == "In Dev";
                }
            );
        }
        table2.draw(); // Make sure this matches the table variable name
    });

    // Correlations Table
    $('#dttb-correlations').DataTable({
        scrollX: true,
        scrollY: "600px",
        scrollCollapse: true,
        paging: false,
        fixedColumns: {
            leftColumns: 1
        }
    });

    // Invoices Table
    $('#dttb-invoices').DataTable({
      paging: true,
      pageLength: 50,
      columnDefs: [ {
        targets: 1,
        // Check if the render.moment function actually exists before calling it
        render: ($.fn.dataTable.render && $.fn.dataTable.render.moment) 
                ? $.fn.dataTable.render.moment('MMM D, YYYY') 
                : null
      },
      { targets: 3, visible: false}
      ],
      order: [[ 1, "desc" ]],
    });

    if ($('#dttb-indices').length > 0 && $.fn.DataTable) {
        $('#dttb-indices').DataTable({
            paging: false,
            columnDefs: [
                {
                    targets: 0,
                    // This will now successfully find the renderer defined in datatables_dates.js
                    render: ($.fn.dataTable.render && $.fn.dataTable.render.moment) 
                            ? $.fn.dataTable.render.moment('MMM D, YYYY') 
                            : null
                }
            ]
        });
    }




});
